








import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "End",
  components: {}
})
export default class End extends Vue {
  @Prop({ default: 156 }) width!: number;

  private style: any = {};

  private created() {
    this.$set(this.style, "width", `${this.width}px`);
  }
}
